const normalizeReferenceValue = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => `${item ?? ''}`.trim())
      .filter(Boolean)
      .join(', ');
  }

  if (typeof value === 'boolean') return value ? 'true' : 'false';
  return `${value ?? ''}`;
};

const normalizeRuleValue = (value) => normalizeReferenceValue(value);

const evalDisplayLabelRule = (rule, rowValues = {}, headers = [], currentHeaderId = '') => {
  const source = normalizeRuleValue(rowValues?.[rule?.whenHeaderId || rule?.headerId]);
  const target = normalizeRuleValue(resolveHeaderReferences(rule?.value, headers, rowValues, currentHeaderId));

  switch (rule?.operator) {
    case 'equals':
      return source === target;
    case 'notEquals':
      return source !== target;
    case 'contains':
      return source.toLowerCase().includes(target.toLowerCase());
    case 'notContains':
      return !source.toLowerCase().includes(target.toLowerCase());
    case 'greaterThan':
      return Number(source) > Number(target);
    case 'lessThan':
      return Number(source) < Number(target);
    case 'isEmpty':
      return source.trim() === '';
    case 'isNotEmpty':
      return source.trim() !== '';
    default:
      return false;
  }
};

export const findHeaderByReferenceName = (headers = [], referenceName = '', currentHeaderId = '') => {
  const normalizedReference = `${referenceName || ''}`.trim().toLowerCase();
  const normalizedCurrentHeaderId = `${currentHeaderId || ''}`.trim();
  if (!normalizedReference) return null;

  return (Array.isArray(headers) ? headers : []).find((header) => {
    const headerId = `${header?.id || ''}`.trim();
    if (!headerId || headerId === normalizedCurrentHeaderId) return false;
    return (
      headerId.toLowerCase() === normalizedReference ||
      `${header?.label || ''}`.trim().toLowerCase() === normalizedReference
    );
  }) || null;
};

export const resolveHeaderReferences = (value = '', headers = [], rowValues = {}, currentHeaderId = '') => (
  `${value ?? ''}`.replace(/\[([^\][]+)\]/g, (match, referenceName) => {
    const referencedHeader = findHeaderByReferenceName(headers, referenceName, currentHeaderId);
    if (!referencedHeader?.id) return match;
    return normalizeReferenceValue(rowValues?.[referencedHeader.id]);
  })
);

export const resolveHeaderFormulaReferences = (formula = '', headers = [], currentHeaderId = '', getReferenceExpression = null) => (
  `${formula ?? ''}`.replace(/\[([^\][]+)\]/g, (match, referenceName) => {
    const referencedHeader = findHeaderByReferenceName(headers, referenceName, currentHeaderId);
    if (!referencedHeader?.id) return match;
    return typeof getReferenceExpression === 'function'
      ? getReferenceExpression(referencedHeader)
      : referencedHeader.id;
  })
);

export const resolveHeaderDisplayName = (header, headers = [], rowValues = {}) => {
  const conditionalRule = (Array.isArray(header?.conditionalDisplayNames || header?.conditionalDisplayLabels)
    ? (header?.conditionalDisplayNames || header?.conditionalDisplayLabels)
    : [])
    .find((rule) => evalDisplayLabelRule(rule, rowValues, headers, header?.id));
  const label = `${conditionalRule?.displayName || conditionalRule?.label || header?.displayName || header?.displayLabel || header?.label || ''}`;
  return resolveHeaderReferences(label, headers, rowValues, header?.id);
};

export const resolveHeaderLabel = resolveHeaderDisplayName;

export const resolveHeaderLabelsForRow = (headers = [], rowValues = {}) => (
  (Array.isArray(headers) ? headers : []).map((header) => ({
    ...header,
    label: resolveHeaderDisplayName(header, headers, rowValues)
  }))
);
